export function nombreArchivoResultado(apellido: string, nombre: string, fecha: string): string {
  const [year, month, day] = fecha.split('-');
  return `${apellido} ${nombre} ${day}-${month}-${year}.pdf`;
}
